import script from "./MyProfileStudent.vue?vue&type=script&setup=true&lang=js"
export * from "./MyProfileStudent.vue?vue&type=script&setup=true&lang=js"

import "./MyProfileStudent.vue?vue&type=style&index=0&id=b60ee3a2&scope=true&lang=css"

const __exports__ = script;

export default __exports__